export default __webpack_public_path__ + "static/media/babavelisekiz4.5ef22146.jpg";